import {
  RegenModal, RegenModalContent, RegenModalTitle,
  RegenOptions, RegenOption, RegenCancelButton,
} from './styled';

interface RegenerateModalProps {
  open: boolean;
  isRegenerating: 'image' | 'text' | 'all' | null;
  onRegenerate: (type: 'image' | 'text' | 'all') => void;
  onClose: () => void;
}

export function RegenerateModal({
  open, isRegenerating, onRegenerate, onClose,
}: RegenerateModalProps) {
  if (!open) return null;

  return (
    <RegenModal onClick={() => !isRegenerating && onClose()}>
      <RegenModalContent onClick={(e) => e.stopPropagation()}>
        <RegenModalTitle>Regenerate Post</RegenModalTitle>
        <RegenOptions>
          <RegenOption
            onClick={() => onRegenerate('image')}
            disabled={!!isRegenerating}
            $loading={isRegenerating === 'image'}
          >
            {isRegenerating === 'image' ? 'Regenerating...' : 'Image Only'}
          </RegenOption>
          <RegenOption
            onClick={() => onRegenerate('text')}
            disabled={!!isRegenerating}
            $loading={isRegenerating === 'text'}
          >
            {isRegenerating === 'text' ? 'Regenerating...' : 'Text Only'}
          </RegenOption>
          <RegenOption
            onClick={() => onRegenerate('all')}
            disabled={!!isRegenerating}
            $loading={isRegenerating === 'all'}
          >
            {isRegenerating === 'all' ? 'Regenerating...' : 'Both (Image + Text)'}
          </RegenOption>
        </RegenOptions>
        {!isRegenerating && (
          <RegenCancelButton onClick={onClose}>
            Cancel
          </RegenCancelButton>
        )}
      </RegenModalContent>
    </RegenModal>
  );
}
